{
  "name": "npy-executive-dashboard-demo",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build-production": "ng build --base-href / --configuration=production",
    "test": "ng test",
    "lint": "ng lint",
    "deploy": "AWS_PROFILE=${AWS_PROFILE:-hutsix-sandbox} sst deploy --stage demo",
    "remove": "AWS_PROFILE=${AWS_PROFILE:-hutsix-sandbox} sst remove --stage demo"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@auth0/angular-jwt": "^5.0.2",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@hutsix/ngxh6": "^5.1.0",
    "@iharbeck/ngx-virtual-scroller": "^18.0.0",
    "@ng-select/ng-select": "^23.5.1",
    "@ngx-pwa/local-storage": "~22.0.0",
    "@ngx-pwa/offline": "~13.0.3",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "@popperjs/core": "^2.11.8",
    "@tweenjs/tween.js": "^25.0.0",
    "bootstrap": "^5.2.0",
    "broadcast-channel": "^7.0.0",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "file-saver": "^2.0.5",
    "marked": "^7.0.3",
    "moment": "^2.29.4",
    "moment-timezone": "^0.5.37",
    "ng2-charts": "^5.0.4",
    "ngx-dropzone-wrapper": "^13.0.0",
    "ngx-indexed-db": "^11.0.2",
    "ngx-json-viewer": "^3.1.0",
    "ngx-moment": "^6.0.2",
    "ngx-papaparse": "^8.0.0",
    "ngx-pipes": "^3.1.0",
    "ngx-quill": "^31.0.1",
    "parchment": "^3.0.0",
    "quill": "^2.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.4.0",
    "ulid": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/build": "^22.1.2",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@angular/localize": "^22.1.0",
    "@aws-sdk/client-sts": "^3.1000.0",
    "@compodoc/compodoc": "^1.1.11",
    "@ng-bootstrap/ng-bootstrap": "~21.0.0",
    "@pulumi/aws": "^6.0.0",
    "@pulumi/command": "^1.0.0",
    "@types/jasmine": "~3.10.3",
    "@types/node": "^22",
    "angular-eslint": "^22.1.0",
    "eslint": "^9.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.0.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "nodemon": "^2.0.19",
    "opn": "^6.0.0",
    "prettier": "^3.0.0",
    "sst": "^3.19.3",
    "ts-node": "~10.7.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.66.0",
    "yalc": "^1.0.0-pre.53"
  },
  "overrides": {
    "@fortawesome/fontawesome-pro": "npm:@fortawesome/fontawesome-free@^6.7.2"
  }
}
